import React, { Component } from 'react';
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {Col, Popover, Row} from "antd";
import './MainFilesList.css';

class MainFilesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSearching: false,
      textSearch: '',
      data: [
        {
          title: 'Archivo 1 nombre de archivo largo y nomo se sabe que tan largo',
          version: 'V1',
          status: 'Nombre estado',
          selected: true,
          selectedIndex: 1,
        },
        {
          title: 'Archivo 2',
          version: 'V2',
          status: 'Nombre estado',
        },
        {
          title: 'Archivo 2',
          version: 'V2',
          status: 'Nombre estado',
          selected: true,
          selectedIndex: 2,
        },
        {
          title: 'Archivo 4',
          version: 'V4',
          status: 'Nombre estado',
          selected: true,
          selectedIndex: 3,
        },
        {
          title: 'Archivo 5',
          version: 'V5',
          status: 'Nombre estado',
        },
        {
          title: 'Archivo 6',
          version: 'V6',
          status: 'Nombre estado',
        },
        {
          title: 'Archivo 7',
          version: 'V7',
          status: 'Nombre estado',
        },
        {
          title: 'Archivo 8',
          version: 'V8',
          status: 'Nombre estado',
        },
      ]
    }
  }

  handleChangeSearch = (e) => {
    this.setState({
      textSearch: String(e.target.value).toUpperCase(),
    })
  }

  render() {
    const {
      intl,
    } = this.props;

    const {
      data,
      isSearching,
      textSearch,
    } = this.state;

    return (
      <div className="bb-comments-block__top">
        <div>
          <h3>{intl.formatMessage({ id: 'files' })}</h3>
          {isSearching ? (
            <div
              className="bb-comments-block__top-search"
              style={{ marginLeft: 15, marginTop: -38, }}
            >
              <svg
                width={15}
                height={14}
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.9">
                  <path
                    d="M6.09375 0C3.25078 0 0.9375 2.31328 0.9375 5.15625C0.9375 7.99922 3.25078 10.3125 6.09375 10.3125C8.93672 10.3125 11.25 7.99922 11.25 5.15625C11.25 2.31328 8.93672 0 6.09375 0ZM6.09375 9.375C3.76781 9.375 1.875 7.48266 1.875 5.15625C1.875 2.83031 3.76781 0.9375 6.09375 0.9375C8.42016 0.9375 10.3125 2.83031 10.3125 5.15625C10.3125 7.48266 8.42016 9.375 6.09375 9.375Z"
                    fill="white"
                  />
                  <path
                    d="M13.9248 12.325L11.1118 9.51246C10.9285 9.32918 10.6323 9.32918 10.449 9.51246C10.2657 9.69574 10.2657 9.99199 10.449 10.1753L13.262 12.9878C13.3534 13.0792 13.4734 13.1251 13.5934 13.1251C13.7134 13.1251 13.8334 13.0792 13.9248 12.9878C14.108 12.8045 14.108 12.5082 13.9248 12.325Z"
                    fill="white"
                  />
                </g>
              </svg>

              <input
                type="text"
                onChange={this.props.searchCommentsFilters}
                value={textSearch}
                placeholder={intl.formatMessage({
                  id: 'search_in_message',
                })}
                // onBlur={this.handleHiddenSearching}
                autoFocus
              />
            </div>
          ) : (
            <div
              // onClick={this.handleShowSearching}
              style={{ cursor: "pointer", display: 'inline', marginBottom: 20, marginLeft: 30 }}
            >
              <svg
                width={18}
                height={18}
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.9">
                  <path
                    d="M6.09375 0C3.25078 0 0.9375 2.31328 0.9375 5.15625C0.9375 7.99922 3.25078 10.3125 6.09375 10.3125C8.93672 10.3125 11.25 7.99922 11.25 5.15625C11.25 2.31328 8.93672 0 6.09375 0ZM6.09375 9.375C3.76781 9.375 1.875 7.48266 1.875 5.15625C1.875 2.83031 3.76781 0.9375 6.09375 0.9375C8.42016 0.9375 10.3125 2.83031 10.3125 5.15625C10.3125 7.48266 8.42016 9.375 6.09375 9.375Z"
                    fill="white"
                  />
                  <path
                    d="M13.9248 12.325L11.1118 9.51246C10.9285 9.32918 10.6323 9.32918 10.449 9.51246C10.2657 9.69574 10.2657 9.99199 10.449 10.1753L13.262 12.9878C13.3534 13.0792 13.4734 13.1251 13.5934 13.1251C13.7134 13.1251 13.8334 13.0792 13.9248 12.9878C14.108 12.8045 14.108 12.5082 13.9248 12.325Z"
                    fill="white"
                  />
                </g>
              </svg>
            </div>
          )}
        </div>
        <div className="c-answer__block main-button-input">
          <input
            className="dart-input-text"
            type="text"
            placeholder={'Buscar...'}
            value={textSearch}
            onChange={this.handleChangeSearch}
          />
        </div>
        <div style={{ height: 'calc(100vh - 300px)' }}>
          <Row gutter={[20,20]} className={'bb-files-block__scroll'} style={{ height: '100%', overflowY: 'auto', }}>
            {textSearch
              ? data.filter(x => String(x.title).toUpperCase().includes(textSearch)).map((item, index) => (
                <Col span={12} key={index}>
                  <div className={item.selected ? 'bb-files-block__card enable' : 'bb-files-block__card'}>
                    {item.selected && <span className={'bb-files-block__tag-selected'}>{item.selectedIndex}</span>}
                      <img className={'bb-files-block__img'} src="https://picsum.photos/300" alt="image_file" />
                      <div style={{ fontSize: 18, fontWeight: 400, marginTop: 10, marginLeft: 2, }}>
                      {
                        item.title.length > 29
                        ? <Popover content={item.title} placement="bottom" >
                            <span dangerouslySetInnerHTML={{ __html: String(`${item.title.slice(0, 28)}...`).toUpperCase().replace(textSearch, `<span style="background: #1C9FDA;color:#FFFFFF;">${textSearch}</span>`) }}></span>
                          </Popover>
                        : <span dangerouslySetInnerHTML={{ __html: String(item.title).toUpperCase().replace(textSearch, `<span style="background: #1C9FDA;color:#FFFFFF;">${textSearch}</span>`) }}></span>
                      }
                    </div>
                    <div style={{ fontSize: 14, fontWeight: 400, marginLeft: 2, marginTop: -5, }}>Version {item.version}</div>
                    <div style={{ fontSize: 14, fontWeight: 400, marginLeft: 2, marginTop: -5, }}>{item.status} <span>s</span></div>
                  </div>
                </Col>
                ))
              : data.map((item, index) => (
              <Col span={12} key={index}>
                <div className={item.selected ? 'bb-files-block__card enable' : 'bb-files-block__card'}>
                  {item.selected && <span className={'bb-files-block__tag-selected'}>{item.selectedIndex}</span>}
                  <img className={'bb-files-block__img'} src="https://picsum.photos/300" alt="image_file" />
                  <div style={{ fontSize: 18, fontWeight: 400, marginTop: 10, marginLeft: 2, }}>
                    {
                      item.title.length > 29
                        ? <Popover content={item.title} placement="bottom" >
                            <span>{`${item.title.slice(0, 28)}...`.toUpperCase()}</span>
                          </Popover>
                        : <span>{String(item.title).toUpperCase()}
                      </span>
                    }
                  </div>
                  <div style={{ fontSize: 14, fontWeight: 400, marginLeft: 2, marginTop: -5, }}>Version {item.version}</div>
                  <div style={{ fontSize: 14, fontWeight: 400, marginLeft: 2, marginTop: -5, }}>{item.status} <span>s</span></div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  const obj = {
    itemSelected: state.comments.itemSelected,
  }

  return obj
}

const mapDispatchToProps = {}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(MainFilesList)))
